import styles from '../TrainMachine.module.css'

function ModelNameDialog({
    isOpen,
    modelName,
    modelNameError,
    onChange,
    onSave,
    onClose,
}) {
    if (!isOpen) return null

    return (
        <div className={styles.modelNameInputDiv}>
            <input
                className={styles.modelNameInput}
                type="text"
                placeholder="Enter model name"
                onChange={onChange}
                value={modelName}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') onSave()
                }}
                onBlur={onSave}
            />
            {modelNameError && (
                <p className={styles.modelNameInputError}>
                    {modelNameError}
                </p>
            )}
        </div>
    )
}

export default ModelNameDialog
